import getFiles from '../../../../../api/preview/edit/getHistoryPreview'
import React, { useEffect, useState } from 'react'

import styled from 'styled-components'
import BaseListFiles, { FileHistory } from './BaseListFiles'
const CLASS_PREFIX = `ListAsync--styledMulitSelectCreatable`

export default function ListFiles({
    onChange,
    select,
    collection
}: {
    onChange: (file: FileHistory) => void
    select: FileHistory
    collection: string
}) {
    return (
        <BaseListFiles
            collection={collection}
            label="Files"
            onChange={onChange}
            select={select}
            getFilesHitory={() => getFiles(collection)}
        />
    )
}
